<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-chevron-right</v-icon>
      Event Review Form
    </v-toolbar>
    <!-- LIST OF SUBMISSIONS -->
    <v-card-text v-if="!editing">
      <v-row>
        <v-col cols="12" md="4" offset-md="8">
          <v-text-field v-model="search" color="secondary" clearable label="Search:" @click:clear="close()"></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="11">Title</v-col>
        <v-col cols="1" class="text-right">Review</v-col>
      </v-row>
      <v-row v-for="(item, i) in searchSubmissions" :key="i" class="subtitle-1 subtable" no-gutters align="center"> 
        <v-col cols="11" class="pl-1">{{item.title}}</v-col>
        <v-col cols="1" class="pr-1 text-right">
          <v-btn icon @click="leaveFeedback(item)">
            <v-icon>far fa-comment</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- REVIEW FORM -->
    <v-card-text v-else>
      <v-toolbar dense color="secondary" dark>
        <v-toolbar-title>Reviewing: {{selected.title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="close()" icon>
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-row>
        <v-col cols="12">
          <v-card flat color="grey lighten-3">
            <i>
              * All fields required.
            </i>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="review.name" outlined color="secondary" label="Your Name:*"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="review.number" outlined color="secondary" label="Approximately how many were present at this event?*"></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="review.numExpected" outlined color="secondary" label="Was this more or less than you expected?*"></v-textarea>
        </v-col>
        <v-col cols="12">
          In your initial request the following was stated for this event's objectives:
          <v-textarea 
            v-model="selected.objectives" 
            background-color="grey lighten-3" 
            outlined color="secondary"
            readonly
          >
          </v-textarea>
        </v-col>
         <v-col cols="12">
          <v-textarea 
            v-model="review.objectives"
            outlined color="secondary"
            label="Describe how those objectives were met or could better be met during future iterations of this event.*"
          >
          </v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="review.highlights" outlined color="secondary" label="What are some highlights you can share from the event?*"></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="review.improvements" outlined color="secondary" label="What are some potential improvements for this event in the future?*"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='6' class="text-center">
          <v-btn outlined color="red" @click="close()">
            <v-icon left>fas fa-times</v-icon>
            Cancel
          </v-btn>
        </v-col>
        <v-col cols='6' class="text-center">
          <v-btn outlined color="secondary" @click="submitReview()" :disabled="verifyReview">
            <v-icon left>fas fa-check</v-icon>
            Submit Review
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    eventInfo : Object
  },
  data(){
    return {
      editing : false,
      event   : this.eventInfo,
      menu    : false,
      review  : {
        highlights  : "",
        improvements: "",
        name        : "",
        number      : "",
        numExpected : "",
        objectives  : ""
      },
      search  : "",
      selected: {}
    }
  },
  methods: {
    close(){
      this.search   = ""
      this.selected = {}
      this.editing  = false
    },
    leaveFeedback(item){
      this.selected = item
      this.editing  = true
    },
    submitReview(){
      let selectedSubmission = this.getSubmissions.filter(sub => sub.id == this.selected.id)[0]
      selectedSubmission.reviews.push(this.review)
      this.$store.dispatch('updateRequest', selectedSubmission)
      let msg = {
        name    : this.review.name,
        email   : this.getSettings.email,
        phone   : "",
        subject : `A review has been entered for ${this.selected.title}.`,
        msg     : `A review has been entered for ${this.selected.title} by ${this.review.name}. Please login to review the information.`
      }
      // this.$store.dispatch('sendMsg', msg)
      this.$router.push('/')
    }
  },
  computed: {
    getSettings(){
      return this.$store.getters.getSettings
    },
    getSubmissions(){
      return this.$store.getters.getSubmissions
    },
    searchSubmissions(){
      let mappedSubmissions = this.getSubmissions.map(sub => {
        let item = {
          id          : sub.id,
          objectives  : sub.objectives,
          title       : sub.startDate.split("-")[0] + " - " + sub.title
        }
        return item
      })
      .sort((a, b) => {
        if (a.title > b.title){
          return 1
        }
        else {
          return -1
        }
      })
      if (this.search == ''){
        return mappedSubmissions
      }
      else {
        return mappedSubmissions.filter(sub => sub.title.toLowerCase().includes(this.search.toLowerCase()))
      }
    },
    verifyReview(){
      if (this.review.highlights != "" && this.review.improvements != "" && this.review.name != "" && this.review.number != "" && this.review.numExpected != "" && this.review.objectives != ""){
        return false
      }
      else {
        return true
      }
    }
  }
}
</script>

<style scoped>
.subtable:nth-child(odd){
  background: #CCC;
}
</style>